module.exports = __webpack_public_path__ + "1ee91a29d84d6e3c6bc04e969d1a43b2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-captain-s.png
// module id = 2250
// module chunks = 0